module.exports = __webpack_public_path__ + "img/yiqian.594a70bc.png";